import React from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import usePowerBiUrl from 'common/hooks/usePowerBiUrl';
import { getTableauReports } from 'features/analyses/tableauService.ts';
import { Constants } from '@pwc/pwc-deals-web-common';
import { getWorkspaceId } from 'features/project/projectSlice';
import {
  postTableauPage,
  postTableauReport,
} from 'features/contentLibrary/libraryItemService';
import { SelectReport } from './SelectReport';
import { SELECT_REPORT_TYPE } from './SelectReportDetail';

export const TableauContainer = ({ show, onHide, onAdd }) => {
  const { projectId } = useParams();
  const workspaceId = useSelector(getWorkspaceId);
  const { t } = useTranslation();
  const emptyTableauList = 'noTableau';

  const createTableauLibraryItem = async (tableauItem, allTabsSelected) => {
    let postTableau;
    if (allTabsSelected) {
      postTableau = await postTableauReport(
        projectId,
        tableauItem.reportId,
        tableauItem.name
      );
    } else {
      postTableau = await postTableauPage(
        projectId,
        tableauItem.reportId,
        tableauItem.tabName,
        tableauItem.tabDisplayName,
        tableauItem.name
      );
    }
    return postTableau;
  };

  return (
    <SelectReport
      show={show}
      workspaceUrl={usePowerBiUrl()}
      workspaceId={workspaceId}
      onAdd={onAdd}
      onHide={onHide}
      title={t('addATableauPage')}
      pageItemType={{
        report: Constants.LIBRARY_ITEM_TYPES.POWER_BI_REPORT.value,
        reportPage: Constants.LIBRARY_ITEM_TYPES.POWER_BI_REPORT_PAGE.value,
      }}
      createReportLibraryItem={createTableauLibraryItem}
      reportIcon={null}
      emptyListMessage={t(emptyTableauList)}
      reportType={SELECT_REPORT_TYPE.TABLEAU}
      getReports={getTableauReports}
    />
  );
};
